/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CheckInternalAccountExistsParams,
  GetAllInternalAccountsParams,
  InternalAccountDTO,
  MemberDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAllInternalAccounts = (
    params?: GetAllInternalAccountsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InternalAccountDTO[]>(
      {url: `/api/internal-accounts`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAllInternalAccountsQueryKey = (params?: GetAllInternalAccountsParams,) => {
    return [`/api/internal-accounts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAllInternalAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getAllInternalAccounts>>, TError = unknown>(params?: GetAllInternalAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllInternalAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllInternalAccountsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllInternalAccounts>>> = ({ signal }) => getAllInternalAccounts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllInternalAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllInternalAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllInternalAccounts>>>
export type GetAllInternalAccountsQueryError = unknown


export function useGetAllInternalAccounts<TData = Awaited<ReturnType<typeof getAllInternalAccounts>>, TError = unknown>(
 params: undefined |  GetAllInternalAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllInternalAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllInternalAccounts>>,
          TError,
          Awaited<ReturnType<typeof getAllInternalAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllInternalAccounts<TData = Awaited<ReturnType<typeof getAllInternalAccounts>>, TError = unknown>(
 params?: GetAllInternalAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllInternalAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllInternalAccounts>>,
          TError,
          Awaited<ReturnType<typeof getAllInternalAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllInternalAccounts<TData = Awaited<ReturnType<typeof getAllInternalAccounts>>, TError = unknown>(
 params?: GetAllInternalAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllInternalAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllInternalAccounts<TData = Awaited<ReturnType<typeof getAllInternalAccounts>>, TError = unknown>(
 params?: GetAllInternalAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllInternalAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllInternalAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateInternalAccount = (
    internalAccountDTO: InternalAccountDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MemberDTO>(
      {url: `/api/internal-accounts`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: internalAccountDTO
    },
      options);
    }
  


export const getUpdateInternalAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInternalAccount>>, TError,{data: InternalAccountDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInternalAccount>>, TError,{data: InternalAccountDTO}, TContext> => {

const mutationKey = ['updateInternalAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInternalAccount>>, {data: InternalAccountDTO}> = (props) => {
          const {data} = props ?? {};

          return  updateInternalAccount(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInternalAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateInternalAccount>>>
    export type UpdateInternalAccountMutationBody = InternalAccountDTO
    export type UpdateInternalAccountMutationError = unknown

    export const useUpdateInternalAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInternalAccount>>, TError,{data: InternalAccountDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInternalAccount>>,
        TError,
        {data: InternalAccountDTO},
        TContext
      > => {

      const mutationOptions = getUpdateInternalAccountMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const createInternalAccount = (
    internalAccountDTO: InternalAccountDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MemberDTO>(
      {url: `/api/internal-accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: internalAccountDTO, signal
    },
      options);
    }
  


export const getCreateInternalAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInternalAccount>>, TError,{data: InternalAccountDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createInternalAccount>>, TError,{data: InternalAccountDTO}, TContext> => {

const mutationKey = ['createInternalAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInternalAccount>>, {data: InternalAccountDTO}> = (props) => {
          const {data} = props ?? {};

          return  createInternalAccount(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateInternalAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createInternalAccount>>>
    export type CreateInternalAccountMutationBody = InternalAccountDTO
    export type CreateInternalAccountMutationError = unknown

    export const useCreateInternalAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInternalAccount>>, TError,{data: InternalAccountDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInternalAccount>>,
        TError,
        {data: InternalAccountDTO},
        TContext
      > => {

      const mutationOptions = getCreateInternalAccountMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const checkInternalAccountExists = (
    params: CheckInternalAccountExistsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/internal-accounts/exists`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCheckInternalAccountExistsQueryKey = (params?: CheckInternalAccountExistsParams,) => {
    return [`/api/internal-accounts/exists`, ...(params ? [params]: [])] as const;
    }

    
export const getCheckInternalAccountExistsQueryOptions = <TData = Awaited<ReturnType<typeof checkInternalAccountExists>>, TError = unknown>(params: CheckInternalAccountExistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkInternalAccountExists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckInternalAccountExistsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkInternalAccountExists>>> = ({ signal }) => checkInternalAccountExists(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkInternalAccountExists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CheckInternalAccountExistsQueryResult = NonNullable<Awaited<ReturnType<typeof checkInternalAccountExists>>>
export type CheckInternalAccountExistsQueryError = unknown


export function useCheckInternalAccountExists<TData = Awaited<ReturnType<typeof checkInternalAccountExists>>, TError = unknown>(
 params: CheckInternalAccountExistsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkInternalAccountExists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkInternalAccountExists>>,
          TError,
          Awaited<ReturnType<typeof checkInternalAccountExists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCheckInternalAccountExists<TData = Awaited<ReturnType<typeof checkInternalAccountExists>>, TError = unknown>(
 params: CheckInternalAccountExistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkInternalAccountExists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkInternalAccountExists>>,
          TError,
          Awaited<ReturnType<typeof checkInternalAccountExists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCheckInternalAccountExists<TData = Awaited<ReturnType<typeof checkInternalAccountExists>>, TError = unknown>(
 params: CheckInternalAccountExistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkInternalAccountExists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCheckInternalAccountExists<TData = Awaited<ReturnType<typeof checkInternalAccountExists>>, TError = unknown>(
 params: CheckInternalAccountExistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkInternalAccountExists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCheckInternalAccountExistsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



